import { Children, ReactNode } from "react";

export const getChildren = (children: ReactNode) => {
  const newChildren = Children.map(children, child => child);
  if (!newChildren) return [];
  return newChildren.filter(child => !!child);
};
